import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Importing translation files

import translationEN from './locales/en/translation.json'
import translationTL from './locales/tl/translation.json'
import translationES from './locales/es/translation.json'
import translationFR from './locales/fr/translation.json'
import translationHN from './locales/hn/translation.json'
import translationJP from './locales/jp/translation.json'
import translationCN from './locales/cn/translation.json'

//Creating object with the variables of imported translation files
const resources = {
	en: {
		translation: translationEN,
	},
	tl: {
		translation: translationTL,
	},
	es: {
		translation: translationES,
	},
	fr: {
		translation: translationFR,
	},
	hn: {
		translation: translationHN,
	},
	jp: {
		translation: translationJP,
	},
	cn: {
		translation: translationCN,
	},
}

//i18N Initialization

i18n.use(initReactI18next).init({
	resources,
	lng: 'en', //default language
	keySeparator: '.',
	interpolation: {
		escapeValue: false,
	},
})

export default i18n
